import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BlockService } from '@share/services/block.service';
import { Block } from '@share/models/block';

export const blockResolver: ResolveFn<Block | null> = (route) => {
  const blockService = inject(BlockService);  
  const idParam = route.paramMap.get('blockId');

  const id = idParam ? Number(idParam) : NaN;

  if (!Number.isFinite(id) || !Number.isInteger(id) || id < 0) {
    return of(null);
  }

  return blockService.getBlockById(id).pipe(
    catchError(() => of(null))
  );
};

